import "core-js/stable";

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import api from "./utils/api";

class CatalogEmbedBootstrap {
  static getQueryValue(keyToFind) {
    const q = document.location.search.substring(1, document.location.search.length);
    for (const token of q.split('&')) {
      const [key, value] = token.split('=');
      if (key === keyToFind) {
        return value;
      }
    }
    return undefined;
  }

  static getInitialProperties() {
    this.initProps = {};
    const catalogScriptTag = document.getElementById('cuxCatalogScriptTag');
    if (catalogScriptTag) {
      this.initProps.token = catalogScriptTag.getAttribute('t');
      this.initProps.staticUrl = catalogScriptTag.getAttribute('s');
      this.initProps.origin = "";
      this.initProps.isAuthenticated = (catalogScriptTag.getAttribute('u') === 'True');
    } else {
      this.initProps.token = this.getQueryValue('t');
      this.initProps.staticUrl = this.getQueryValue('s');
      this.initProps.origin = this.getQueryValue('o');
      this.initProps.isAuthenticated = (this.getQueryValue('u') === 'True');
    }
    return this.initProps;
  }

}

const initProperties = CatalogEmbedBootstrap.getInitialProperties();

const catalogCSSLink = document.createElement('link');
catalogCSSLink.rel = "stylesheet";
catalogCSSLink.href = initProperties.staticUrl+"catalog/app.css";

const catalogMainContainer = document.createElement('main');
catalogMainContainer.setAttribute('id', 'main');
catalogMainContainer.setAttribute('class', 'container');
const catalogAppContainer = document.createElement('div');
catalogAppContainer.id = "catalogApp";
if (document.getElementById('cuxCatalogScriptTag')){
  document.getElementById('cuxCatalogScriptTag').parentElement.appendChild(catalogAppContainer);
  document.getElementById('cuxCatalogScriptTag').parentElement.appendChild(catalogCSSLink);
} else {
  document.body.appendChild(catalogMainContainer);
  catalogMainContainer.appendChild(catalogAppContainer);
  document.body.appendChild(catalogCSSLink);
}

if (initProperties.token) {
  api.defaults.headers["X-CU-Security"] = initProperties.token
  const root = ReactDOM.createRoot(document.getElementById('catalogApp'))
  root.render(<App token={initProperties.token} staticUrl={initProperties.staticUrl} hostOrigin={initProperties.origin} isAuthenticated={initProperties.isAuthenticated} />);
} else {
  catalogAppContainer.append('<p>We had a problem loading your catalog</p>');
}